//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalPlayersPv',
  data() {
    return {
      title: 'Verify your account',
      content: `
            <p>Disfruta al máximo de los beneficios que te ofrecemos en 777 al verificar tu cuenta. ¡Es muy fácil! Solo debes enviar una foto digital legible por ambas caras del documento con el que te has registrado.</p>
            <p>Este procedimiento es por tu seguridad para poder confirmar tu identidad y es obligatorio para el retiro de tus ganancias, participar en promociones o depositar más de 150€.</p>      
      `,
      isOpen: false
    }
  },
  watch: {
    isOpen: function(){
      if (this.isOpen) {
        this.$store.commit('addModal', this.$options.name)
      } else {
        this.$store.commit('removeModal', this.$options.name)
      }    
    }
  },
  mounted() {
    window.addEventListener('message', message => {
        if(_.includes(message.data, 'close')) {
          this.close();
        }
    });
    
  },
  methods: {
    checkOpenModal() {
      for (let i = 0; i < this.$store.state.openedModals.length; i++) {
        if (this.$store.state.openedModals[i] !== this.$options.name) {
          return false
        }
      }
      return true
    },
    opened() {
      this.isOpen = true;
    },
    beforeOpen (event) {
      console.info(event)
      window.dispatchEvent(new Event('resize'));

      if (_.get(event, 'params')) {
        this.title = _.get(event, 'params.title', '')
        this.content = _.get(event, 'params.content', '')
      }
    },
    close() {
      this.isOpen = false;
      this.$modal.hide('modal-players-pv')
    },    
    async submit() {}
  }
}
